import { supportApi } from '@/api/endpoints/support';
import { salvarArquivo } from '@/lib/arquivos';

// Salva o arquivo da mensagem com o nome original. Vai pela API porque o
// domínio público das mídias não manda CORS; se a API falhar, abre o link
// numa aba nova (o atendente ainda consegue salvar pelo navegador).
export async function baixarMidia(
  messageId: number,
  nome: string,
  urlReserva?: string
): Promise<void> {
  try {
    const blob = await supportApi.downloadMedia(messageId);
    // No app abre a folha de compartilhar do sistema (ver lib/arquivos).
    await salvarArquivo(blob, nome);
  } catch {
    if (urlReserva) window.open(urlReserva, '_blank', 'noopener,noreferrer');
  }
}
